import { Navigate } from 'react-router-dom';
import { useDynamicPricingStore } from '../store/dynamic-pricing-store';
import { rutaDeLaPestana } from './puente-de-pestanas';

/**
 * `/dynamic-pricing` → la vista de Compite equivalente. Lee la pestaña que el
 * store tenga elegida: quien hacía `setActiveTab('monitoring')` y después
 * navegaba a Precios Dinámicos llega a Competencia › Lecturas programadas.
 * Sin pestaña elegida (la de inicio, «overview»), a Monitoreo.
 */
export function RedirigirPreciosDinamicos() {
  const { activeTab, productsPrefilter } = useDynamicPricingStore.getState();
  return (
    <Navigate
      to={rutaDeLaPestana(activeTab, { tiendaDeProductos: productsPrefilter?.storeId })}
      replace
    />
  );
}
